<template>
    <div class="card">
        <div v-if="view.view_type !== 'custom'" class="d-flex flex-column my-2">

            <div class="ms-2 mb-2">
                <strong>Fields</strong>
            </div>

            <ul class="list-group">
                <Container key="fieldOptions" behaviour="copy" group-name="fieldOptions"
                           :get-child-payload="getCurrentField">
                    <Draggable v-for="field in table.fields" :key="field.name">

                        <li class="list-group-item draggable-item pointer">

                            <div class="d-flex justify-content-center align-items-center">
                                <i class="fad me-2 mt-1 text-primary" :class="getClass(field)" style="color: #cccccc"> </i>
                                <div class="mt-1">{{field.name}}</div>
                                <i class="fa fa-ellipsis-v drag-icon ms-auto" aria-hidden="true"></i>
                            </div>

                        </li>
                    </Draggable>
                </Container>
            </ul>

        </div>

        <div class="d-flex flex-column my-2">

            <div class="ms-2 mb-2">
                <strong>Components</strong>
            </div>

            <Container key="componentOptions" behaviour="copy" group-name="componentOptions"
                       :get-child-payload="getCurrentComponent">
                <Draggable v-for="componentType in model.componentTypes" :key="componentType">

                    <li class="list-group-item draggable-item pointer">
                        <div class="d-flex justify-content-center align-items-center">
                            <i class="me-2 mt-1 text-primary" :class="getComponentClass(componentType)"> </i>
                            <div class="mt-1">{{componentType}}</div>
                            <i class="fa fa-ellipsis-v drag-icon ms-auto" aria-hidden="true"></i>
                        </div>
                    </li>

                </Draggable>
            </Container>

        </div>

        <div class="d-flex flex-column my-2">

            <div class="ms-2 mb-2">
                <strong>Views</strong>
            </div>

            <Container key="availableViewOptions" behaviour="copy" group-name="availableViewOptions"
                       :get-child-payload="getAvailableView">
                <Draggable v-for="availableView in availableViews" :key="availableView.id + 'AvailableView'">

                    <li class="list-group-item draggable-item pointer">

                        <div class="d-flex justify-content-center align-items-center">
                            <i class="me-2 mt-1 text-primary fad fa-browser" style="color: #cccccc"></i>
                            <div class="mt-1">{{availableView.name}}</div>
                            <i class="fa fa-ellipsis-v drag-icon ms-auto" aria-hidden="true"></i>
                        </div>

                    </li>
                </Draggable>
            </Container>

        </div>
    </div>
</template>

<script>
    import {Container, Draggable} from "vue3-smooth-dnd"
    import LayoutFactory from "../../utils/LayoutFactory";
    import PageFactory from "../../utils/PageFactory";

    export default {
        name: 'ComponentSelector',
        props: ['table', 'view'],
        components: {
            Container,
            Draggable
        },
        data() {
            return {
                model: webase.model,
                factory: new LayoutFactory(this.table),
                pageFactory: new PageFactory()
            }
        },
        computed: {
            availableViews() {
                return this.table.views.filter(view => view.id !== this.view.id)
            }
        },
        mounted() {
        },
        methods: {
            getCurrentField(index) {
                let field = this.table.fields[index]
                let fieldComponent = this.factory.createFieldComponent(field)
                this.factory.decorateFieldComponent(field, fieldComponent)
                return fieldComponent
            },
            getAvailableView(index) {
                let view = this.availableViews[index]

                let payload = {
                    type: 'View',
                    value: view.id,
                    showHeader: true,
                    margin: {
                        side: 'none',
                        value: '0'
                    },
                    padding: {
                        side: 'none',
                        value: '0'
                    }
                }

                return payload
            },
            getCurrentComponent(index) {
                let componentType = this.model.componentTypes[index]

                if(componentType === 'Button') {
                    return this.getButton(componentType)
                }
                else if(componentType === 'Link') {
                    return this.pageFactory.createLink('New Link')
                }
                else if(componentType === 'Header') {
                    return this.pageFactory.createHeaderComponent('New Header')
                }

                // currently creates a Label or a Header.... enhance to support other component types
                let payload = this.factory.createHtmlComponent(componentType, 'New ' + componentType)
                return payload
            },
            getButton(buttonType) {
                return this.factory.createButton('New ' +  buttonType)
            },
            getClass(field) {
                return webase.utils.ui.getClass(field)
            },
            getComponentClass(componentType) {
                return webase.utils.ui.getComponentClass(componentType)
            }
        }
    }
</script>
